import React, { useContext } from 'react';
import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
} from 'reactstrap';

import { Text } from '~/components/Text';
import { LoaderMini } from '~/components/Loaders';
import { symbolPriceFormatter } from '~/helpers/price';
import { color } from '~/assets/styles/colors';
import money from '~/assets/img/money.svg';

import { AutorizarSaldo } from '~/components/AutorizarSaldoRevenda';
import { DivMontante, ImgMontante, TextMontante } from './styles';

import { ExtratoContext } from '../../../context/ExtratoContext';
import { PedidoContext } from '../../../context/PedidoContext';

function AutorizarCred(props) {
	const { user, isMobile } = props;

	const {
		dataSolicitacoes,
		setDataSolicitacoes
	} = useContext(PedidoContext);

	const { dataSaldo, loadingSaldo } = useContext(ExtratoContext);

	return (
		<Container fluid>
			<Row>
				<Col sm="12" md="8" lg="9">
					<Card
						style={{
							backgroundColor: 'transparent',
							boxShadow: 'unset',
							borderRadius: '0px 18px 18px 18px',
						}}>
						<CardBody>
							<Row>
								{user.dados.cargo.toLowerCase() === '' ? (
									<Col sm="12" md="12" lg="12">
										<Text>AUTORIZAR VISUALIZAÇÃO DE CRÉDITO</Text>
										<AutorizarSaldo
											isMobile={isMobile}
											setDataSolicitacoes={setDataSolicitacoes}
											solicitacoes={dataSolicitacoes && dataSolicitacoes.solicitacoes ? dataSolicitacoes.solicitacoes : []}
											user={user}
											totalItems={dataSolicitacoes ? dataSolicitacoes.total_paginas : 1} />
									</Col>
								) : (
									<></>
								)}
							</Row>
						</CardBody>
					</Card>
				</Col>
				<Col sm="12" md="4" lg="3">
					<Text style={{ textAlign: 'right' }}>Meus Créditos</Text>
					<Card
						style={{
							marginBottom: 0,
							backgroundColor: color.secondary,
						}}>
						<CardBody className="py-4 px-2">
							<DivMontante>
								{loadingSaldo ? (
									<LoaderMini />
								) : (
									<>
										<TextMontante
											style={{ marginRight: '5%' }}>
											<Text
												color="softBlack"
												size="big">
												{symbolPriceFormatter(
													dataSaldo.saldo
												)}
											</Text>
										</TextMontante>
										<ImgMontante
											alt="money"
											width="20"
											src={money}
										/>
									</>
								)}
							</DivMontante>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}

export default AutorizarCred;
